import { render, staticRenderFns } from "./TeacherEvaluation.vue?vue&type=template&id=600d48d2&scoped=true"
import script from "./TeacherEvaluation.vue?vue&type=script&lang=js"
export * from "./TeacherEvaluation.vue?vue&type=script&lang=js"
import style0 from "./TeacherEvaluation.vue?vue&type=style&index=0&id=600d48d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600d48d2",
  null
  
)

export default component.exports